import React from "react";
import Button from "@components/Button/Button";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { startScreenNavigation } from "@telemetry/navigationTiming";
import { paths } from "@utils/navigation";
import { checkPermission } from "@utils/user-permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const RequestPortOperatorLicense: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userActionPermissions } = useAuthStore();

  const hasPermission = checkPermission(userActionPermissions, "canRequestPortOperatorLicense");

  if (!hasPermission) return null;

  const handleClick = () => {
    startScreenNavigation("Licenses", window.location.pathname, "Port Operator License Request");
    navigate(`/${paths.licenses.index}/${paths.licenses.portOperatorLicenseRequest}`);
  };

  return (
    <Button
      testId="request-port-operator-license"
      variant="contained"
      type="button"
      className="whitespace-nowrap"
      onClick={handleClick}
      label={
        <span className="normal-case font-medium">
          {t("licensing.request-port-operator-license")}
        </span>
      }
    />
  );
};

export default RequestPortOperatorLicense;
